export default __webpack_public_path__ + "static/media/Slaton-Gray-Moss-Charcoal.fd8ac3f9.jpg";